import { RouteConfig } from 'vue-router'
import VueI18n from 'vue-i18n'

const AppListView: DynamicImport = () => import(/* webpackChunkName: "admin" */ '../views/Root/AppListView.vue')
const AppFormView: DynamicImport = () => import(/* webpackChunkName: "admin" */ '../views/Root/AppFormView/AppFormView.vue')
const AppItemView: DynamicImport = () => import(/* webpackChunkName: "admin" */ '../views/Root/AppItemView/AppItemView.vue')
const LoginPageListView: DynamicImport = () => import(/* webpackChunkName: "accountant" */ '../views/Root/LoginPageListView.vue')
const MyAppView: DynamicImport = () => import(/* webpackChunkName: "admin" */ '../views/Admin/MyAppView/MyAppView.vue')
const TeamListView: DynamicImport = () => import(/* webpackChunkName: "admin" */ '../views/Admin/TeamListView.vue')
const TeamItemView: DynamicImport = () => import(/* webpackChunkName: "admin" */ '../views/Admin/TeamItemView/TeamItemView.vue')
const CommandListView: DynamicImport = () => import(/* webpackChunkName: "admin" */ '../views/Admin/CommandListView.vue')
const AccountantListView: DynamicImport = () => import(/* webpackChunkName: "admin" */ '../views/Root/AccountantListView.vue')
const AccountantItemView: DynamicImport = () => import(/* webpackChunkName: "admin" */ '../views/Root/AccountantItemView/AccountantItemView.vue')
const SponsorshipListView: DynamicImport = () => import(/* webpackChunkName: "admin" */ '../views/Root/SponsorshipListView.vue')

const AccountantTeamList: DynamicImport = () => import(/* webpackChunkName: "accountant" */ '../views/Accountant/TeamListView.vue')
const AccountantTeamItem: DynamicImport = () => import(/* webpackChunkName: "accountant" */ '../views/Accountant/TeamItemView/TeamItemView.vue')
const AccountantInvitationsView: DynamicImport = () => import(/* webpackChunkName: "accountant" */ '../views/Accountant/InvitationsView.vue')
const AccountantFecDownload: DynamicImport = () => import(/* webpackChunkName: "accountant" */ '../views/Accountant/FecDownloadView.vue')
const InvitationNewAccountView: DynamicImport = () => import(/* webpackChunkName: "accountant" */ '../views/Accountant/InvitationNewAccountView.vue')


const routes: (i18n: VueI18n) => RouteConfig[] = () => ([
  {
    path: '/admin/app',
    name: 'admin-app-list',
    component: AppListView,
    meta: {
      title: 'Gestion des applications',
      pageHeader: false,
      userPermission: ['root-app', 1],
      onlyRoot: true
    }
  },
  {
    path: '/admin/app/form/:id?',
    name: 'admin-app-form',
    component: AppFormView,
    meta: {
      pageHeader: false,
      title: 'Gestion d\'une application',
      userPermission: ['root-app', 1],
      onlyRoot: true
    }
  },
  {
    path: '/admin/app/:id?',
    name: 'admin-app-item',
    component: AppItemView,
    meta: {
      pageHeader: false,
      title: 'Fiche application',
      userPermission: ['root-app', 1],
      onlyRoot: true
    }
  },
  {
    path: '/admin/login-page',
    name: 'admin-login-page',
    component: LoginPageListView,
    meta: {
      pageHeader: false,
      title: 'Pages d\'accueil',
      userPermission: ['root-app', 1],
      onlyRoot: true
    }
  },
  {
    path: '/admin/accountant',
    name: 'admin-accountant-list',
    component: AccountantListView,
    meta: {
      title: 'Gestion des experts-comptable',
      pageHeader: false,
      userPermission: ['root-app', 1],
      onlyRoot: true
    }
  },
  {
    path: '/admin/accountant/:id?',
    name: 'admin-accountant-item',
    component: AccountantItemView,
    meta: {
      title: 'Fiche expert-comptable',
      userPermission: ['root-app', 1],
      onlyRoot: true
    }
  },
  {
    path: '/admin/my-app',
    name: 'admin-my-app',
    component: MyAppView,
    meta: {
      pageHeader: false,
      title: 'Configuration de l\'application',
      userPermission: ['manage-app', 1],
      rootOrAdmin: true
    }
  },
  {
    path: '/admin/team',
    name: 'admin-team-list',
    component: TeamListView,
    meta: {
      pageHeader: false,
      title: 'Gestion des comptes',
      userPermission: ['manage-app', 1],
      rootOrAdmin: true
    }
  },
  {
    path: '/admin/team/:id',
    name: 'admin-team-item',
    component: TeamItemView,
    meta: {
      pageHeader: false,
      title: 'Fiche du compte',
      userPermission: ['manage-app', 1],
      rootOrAdmin: true
    }
  },
  {
    path: '/admin/command-list',
    name: 'admin-command-list',
    component: CommandListView,
    meta: {
      title: 'Liste des commandes',
      userPermission: ['manage-app', 1],
      rootOrAdmin: true
    }
  },

  {
    path: '/accountant/invitations',
    name: 'accountant-team-invitations',
    component: AccountantInvitationsView,
    meta: {
      title: 'Gestion des invitations',
      onlyAccountant: true
    }
  },
  {
    path: '/accountant/invitation/:token',
    name: 'accountant-team-invitation',
    component: InvitationNewAccountView,
    meta: {
      title: 'Créer mon compte expert-comptable',
      isPublic: true
    }
  },
  {
    path: '/accountant/team',
    name: 'accountant-team-list',
    component: AccountantTeamList,
    meta: {
      title: 'Liste des comptes managés',
      onlyAccountant: true,
      pageHeader: false
    }
  },
  {
    path: '/accountant/team/:id',
    name: 'accountant-team-item',
    component: AccountantTeamItem,
    meta: {
      title: 'Fiche',
      pageHeader: false,
      onlyAccountant: true
    }
  },
  {
    path: '/accountant/team/:teamId/fec-export/:id/download',
    name: 'accountant-fec-download',
    component: AccountantFecDownload,
    meta: {
      pageHeader: false,
      title: 'Téléchargement',
      onlyAccountant: true
    }
  },
  {
    path: '/admin/sponsorship',
    name: 'root-sponsorships',
    component: SponsorshipListView,
    meta: {
      title: 'Gestion des commissions',
      userPermission: ['root-app', 1],
      onlyRoot: true
    }
  }
])

export default routes
